import { TOWER_MENU_ITEMS } from '@silverfort-nodelibs/common/utils/consts';
import { Icons, MenuItem } from '@silverfort/sf-components';
import { LogicalItemsTypes } from '../../../TowerMenu/logicalMenuItems/LogicalItemsTypes';
import { useSassRestrictions } from '../../../context/contexts/SassRestrictionsContext';

export const AuthenticationFirewallMenuItems = ({
    handleMenuItemSelection,
    getTowerMenuHref,
    ...props
}: Omit<LogicalItemsTypes, 'userData'>) => {
    const { restrictedSaasSupportMode } = useSassRestrictions();
    const disabled = restrictedSaasSupportMode;

    return (
        <MenuItem
            {...props}
            id={TOWER_MENU_ITEMS.AUTHENTICATION_FIREWALL}
            ItemIcon={Icons.Shield}
            title="Authentication Firewall">
            <MenuItem
                disabled={disabled}
                href={getTowerMenuHref(TOWER_MENU_ITEMS.AUTHENTICATION_FIREWALL_DASHBOARD)}
                id={TOWER_MENU_ITEMS.AUTHENTICATION_FIREWALL_DASHBOARD}
                title="Dashboard"
            />
        </MenuItem>
    );
};
